import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../storeUtils";
import * as UtilsHelper from "../../../utils/utilsHelper";
import _ from "underscore";

const initialState = {
  screeningResponse: [],
  downloadingFiles: [],
  downLoader: false,
  fileDownloadDetails: {},
  previewFileURL: "",
  fileName: "",
  fileType: "",
  previewLoading: false,
  singleFile: { uploadingProgress: 0 },
  isScanning: false,
  saveChanges: false,
  scanSuccessInfo: {},
  fileErrorMessage: "",
  singleFileErrorMessage: ""
};

export const fileUploadReducer = (
  state = initialState,
  action = { type: "" }
) => {
  switch (action.type) {
    case actionTypes.FILE_DOWNLOAD_URL:
      let downloadingFiles = state.downloadingFiles;
      downloadingFiles.push(action.tmpFileGuid ? action.tmpFileGuid : action.payload.requestPaylod.fileguid);
      return updateObject(state, {
        downloadingFiles: downloadingFiles,
        downLoader: true,
      });
    case actionTypes.FILE_DOWNLOAD_URL_SUCCESS:
      const removeFiles = state.downloadingFiles.filter(
        (id) => id !== action.documentid
      );
      return updateObject(state, {
        fileDownloadDetails: action.payload,
        downloadingFiles: removeFiles,
        downLoader: false,
      });
    case actionTypes.FILE_DOWNLOAD_URL_FAILED:
      return updateObject(state, {
        fileDownloadDetails: {},
        downloadingFiles: [],
        downLoader: false,
      });

    case `${actionTypes.FILE_DOWNLOAD_URL}_DIALOG_FAILED`:
      return updateObject(state, {
        fileErrorMessage: action.payload,
        fileDownloadDetails: {},
        downloadingFiles: [],
        downLoader: false,
      });

    case actionTypes.CLEAR_FILEERROR_MESSAGE:
      return updateObject(state, {
        fileErrorMessage: "",
      });

    case `${actionTypes.SCANNING_PROCESS_STATUS}`:
      return updateObject(state, {
        isDocumentUploading: true,
      });
    case `${actionTypes.SCANNING_PROCESS_STATUS}_SUCCESS`:
      let screenResponse = state.screeningResponse;
      screenResponse.push(action.payload);
      return updateObject(state, {
        scanSuccessInfo: { ...action.payload, isAllowToCancel: false },
        screeningResponse: screenResponse,
        isDocumentUploading: false,
      });
    case `${actionTypes.SCANNING_PROCESS_STATUS}_FAILED`:
      return updateObject(state, {
        scanFailedInfo: { ...action.payload, isAllowToCancel: false },
        isDocumentUploading: false,
      });

    case actionTypes.FILE_PREVIEW_URL:
      return updateObject(state, {
        previewFileURL: "",
        isPreviewLoading: true,
        previewLoading: true
      });
    case `${actionTypes.FILE_PREVIEW_URL}_SUCCESS`:
      return updateObject(state, {
        previewFileURL: action.payload,
        fileName: action.fileName,
        fileType: action.fileType,
        isPreviewLoading: false,
        requestPayload: action.requestPayload,
        previewLoading: false
      });

    case `${actionTypes.FILE_PREVIEW_URL}_FAILED`:
      return updateObject(state, {
        previewFileURL: "",
        fileName: "",
        fileType: "",
        isPreviewLoading: false,
        previewLoading: false
      });

    case `${actionTypes.CREATE_NEW_DOC_VERSION}`:
      return updateObject(state, { isScanning: true, saveChanges: false });
    case `${actionTypes.CREATE_NEW_DOC_VERSION}_SUCCESS`:
      if (action.from !== "Cancel") {
        return updateObject(state, {
          isScanning: !action.payload.isscancompleted,
          saveChanges: true,
          isScanFailed: false,
          isAllowToCancel: true,
        });
      } else
        return updateObject(state, {
          isScanFailed: false,
          saveChanges: false,
        });
    case `${actionTypes.CREATE_NEW_DOC_VERSION}_FAILED`:
      return updateObject(state, {
        isScanFailed: true,
        isScanning: false,
        saveChanges: false,
      });

    case actionTypes.SINGLE_FILE_PROGRESSING:
      let newPayload = { ...action.payload };
      if (_.isEmpty(newPayload)) {
        const { uploadingProgress, id } = state.singleFile;
        let newUploadingProgress =
          uploadingProgress <= 92
            ? uploadingProgress + UtilsHelper.randomNumber([14, 16, 29])
            : uploadingProgress;
        newPayload = {
          id,
          uploadingProgress: newUploadingProgress,
        };
      }
      return updateObject(state, {
        isScanning: !_.isEmpty(newPayload.id),
        singleFile: newPayload,
      });
    case actionTypes.SHOW_DOWNLOAD_LOADER:
      return updateObject(state, { downLoader: action.payload });
    case actionTypes.SINGLE_FILE_ERROR_TOASTER:
      return updateObject(state, { singleFileErrorMessage: action.payload });  
    default:
      return state;
  }
};
